import useAuth from "./useAuth";
import useEmployees from "./useEmployee";
import useEmployers from "./useEmployer";
import useMasterQuestion from "./useMasterQuestion";
import useMember from "./useMember";
import usePages from "./usePages";
import useProfile from "./useProfile";
import useQuestionaries from "./useQuestionaries";
import useQuestionariesSubTag from "./useQuestionSubTag";
import useSubTags from "./useSubTags";
import useUser from "./useUser";

const containers = {
  auth: useAuth,
  profile: useProfile,
  user: useUser,
  member: useMember,
  pages: usePages,
  questionaries: useQuestionaries,
  employees: useEmployees,
  employers: useEmployers,
  questionariessubtag: useQuestionariesSubTag,
  masterQuestion: useMasterQuestion,
  subTags: useSubTags,
};

export default containers;
